import { showNotification } from '@mantine/notifications';
import { useApi } from 'api/api-context';
import { OnStatusChange, RevisionActionRevision } from 'components/tables/data/revision/types';
import panic from 'errors/panic';
import { noop } from 'lodash';
import { SUCCESS_NOTIFICATION_COLOR } from 'utils/constants';

/**
 * Implements self-assignment for an eligible free revision or form.
 */
export default function useAssignToSelfAction() {
  const { getAction } = useApi();

  /** Assigns the record and propagates its accepted state and technician. */
  async function assignToSelf({
    revision,
    onStatusChange = noop,
  }: {
    revision: RevisionActionRevision;
    onStatusChange?: OnStatusChange;
  }) {
    const action = getAction('RevisionAssignToSelf');

    try {
      const { status, technician } = await action({ parameters: { revisionId: String(revision.revisionId) } });

      onStatusChange({ revisionId: revision.revisionId, status, technician });
      showNotification({
        title: revision.kind === 'revision' ? 'Revízna správa bola pridelená' : 'Formulár bol pridelený',
        message:
          revision.kind === 'revision'
            ? `Revíznu správu ${revision.revisionName} ste si úspešne pridelili.`
            : `Formulár ${revision.revisionName} ste si úspešne pridelili.`,
        color: SUCCESS_NOTIFICATION_COLOR,
      });
    } catch (error: any) {
      panic(error);
    }
  }

  return { assignToSelf };
}
